<template>
  <div id="app">
    <template v-if="isRouterAlive">
      <keep-alive>
          <router-view v-if="keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!keepAlive"></router-view>
    </template>
    <div v-show="loadingVisible" class="loading_cover"><img class="loading_icon" src="./components/base/img/loading.gif" alt="" srcset=""></div>
  </div>
</template>
<script>
  //首页引入base.scss
  import 'ASSETS/scss/common/base.scss'

  export default {
    provide () {    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
      return {
        reload: this.reload
      }
    },
    data() {
      return {
        isRouterAlive:true,
      }
    },
    computed:{
      loadingVisible(){
        return this.$store.state.isLoading
      },
      keepAlive(){
        return this.$route.meta.keepAlive
      }
    },
    methods: {
      reload () {
          this.isRouterAlive = false;            //先关闭，
          this.$nextTick(function () {
              this.isRouterAlive = true;         //再打开
          }) 
      }
    },
    async created() {
      this.$store.commit("setLoading",false)
      if (localStorage.getItem('token')) {
        this.$fetchUserProfile();
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  * {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }
  #app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin: 0;
    padding: 0;
  }
  .loading_cover{
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 1000;
    top: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    .loading_icon{
      position: absolute;
      top: 50%;
      left: 50%;
      width: 100px;
      transform: translate(-50%,-50%);
    }
  }
</style>
